import { memo, useCallback, useMemo } from "react";

import { SaleTypeForPlan } from "@/lib/gql/__generated__/graphql";

import { RadioGroupField } from "@/components/ui/form/fields/radio-field/radio-group";

import * as Constants from "./constants";
import { FormFieldLayout } from "../../layouts";

type Props = {
	// プラン限定のディスカウントかどうか
	saleTypeForPlan: SaleTypeForPlan;
	// ディスカウントをプラン限定にするかの変更
	onChangeSaleTypeForPlan: (value: SaleTypeForPlan) => void;
};

export const SaleTypeForPlanFormFieldComposition = memo(({ saleTypeForPlan, onChangeSaleTypeForPlan }: Props) => {
	/**
	 * ディスカウントをプラン限定にするかの変更
	 */
	const handleChangeSaleTypeForPlan = useCallback(
		(value: string) => {
			onChangeSaleTypeForPlan(value as SaleTypeForPlan);
		},
		[onChangeSaleTypeForPlan],
	);

	/**
	 * 注意書きの表示制御
	 */
	const canShowSaleForTypePlanNote = useMemo(() => saleTypeForPlan === SaleTypeForPlan.Limited, [saleTypeForPlan]);

	return (
		<FormFieldLayout title="プラン限定">
			<RadioGroupField
				value={saleTypeForPlan}
				options={Constants.SaleTypeForPlanOptions}
				handleValueChange={handleChangeSaleTypeForPlan}
			/>

			<div className="mt-2 space-y-2">
				{canShowSaleForTypePlanNote && (
					<p className="text-sm font-medium text-error-600">
						※公開している全ての部屋が「プラン限定販売」の場合、プランが選択されるまで、予約ページのカレンダーでは全ての日付で「×」が表示されます。
					</p>
				)}

				<p className="whitespace-pre-wrap text-sm text-caption-50">
					{`特別なプランだけに適応できるディスカウントに設定することもできます。\n素泊まりにも適応可能なディスカウントの場合は”常に販売”を選びましょう。`}
				</p>
			</div>
		</FormFieldLayout>
	);
});
